import StepOne from "@/components/dashboard/moneyExchange/StepOne";

export default function MoneyExchangeStepOne() {
  return <StepOne />;
}
